import {Component, Input, OnInit} from '@angular/core';
import {Accessory} from "../../models/accessory";
import {Store} from "@ngxs/store";
import {Product} from "../../models/product";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ColorProperty} from "../../models/color-property";

@Component({
  selector: 'app-accessory-card',
  templateUrl: './accessory-card.component.html',
  styleUrls: ['./accessory-card.component.scss']
})
export class AccessoryCardComponent implements OnInit {
  @Input() accessory: Accessory;
  @Input() product: Product;
  @Input() form: FormGroup;

  numberInConfiguration: number;

  idForSelectedColorProperty: string;
  availableColorProperties: ColorProperty[];

  idForSelectedWidth: string;
  idForSelectedSide: string;


  constructor(private store: Store, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.numberInConfiguration = this.accessory.numberInConfiguration;

    this.availableColorProperties = this.accessory?.colorVariations?.reduce((array, item) => {
      if (item.colorProperty && !array.find(a => a.id === item.colorProperty.id)) {
        array.push(item.colorProperty)
      }
      return array;
    }, []);

    if (this.availableColorProperties.length > 0) {
      this.idForSelectedColorProperty = `${this.product.configurationId}-${this.accessory.id}-selectedColorProperty`;
      const selectedColorPropertyIndex = this.availableColorProperties.findIndex(colorProperty => colorProperty.id === this.product.selectedVariation.colorProperty.id);
      this.form.addControl(this.idForSelectedColorProperty, this.fb.control(this.availableColorProperties[selectedColorPropertyIndex]?.id));
      if (this.accessory.selectedAccessoryVariation) this.form.controls[this.idForSelectedColorProperty].setValue(this.accessory.selectedAccessoryVariation.colorProperty.id);
    }

    if (this.accessory.sideVariations.length > 0) {
      this.idForSelectedSide = `${this.product.configurationId}-${this.accessory.id}-selectedSide`;
      this.form.addControl(this.idForSelectedSide, this.fb.control(this.accessory.sideVariations[0]?.side));
      if (this.accessory.selectedAccessoryVariation) this.form.controls[this.idForSelectedSide].setValue(this.accessory.selectedAccessoryVariation.side);
    }

    if (this.accessory.widthVariations.length > 0) {
      this.idForSelectedWidth = `${this.product.configurationId}-${this.accessory.id}-selectedWidth`;
      this.form.addControl(this.idForSelectedWidth, this.fb.control(this.accessory.widthVariations[0]?.width));
      if (this.accessory.selectedAccessoryVariation) this.form.controls[this.idForSelectedWidth].setValue(this.accessory.selectedAccessoryVariation.width);
    }
  }

  addAccessory() {
    this.form.controls[`${this.accessory.id}-number`].setValue(this.form.controls[`${this.accessory.id}-number`].value + 1)
  }

  removeAccessory() {
    this.form.controls[`${this.accessory.id}-number`].setValue(this.form.controls[`${this.accessory.id}-number`].value - 1)
  }

  removeButtonIsDisabled(): boolean {
    return this.form.controls[`${this.accessory.id}-number`].value < 1;
  }

  getPriceForAccessory(): number {
    const selectedVariation = this.accessory.colorVariations.find(variation => {
      return variation.colorProperty?.id === this.form.controls[this.idForSelectedColorProperty].value
    })
    return selectedVariation ? selectedVariation.price : this.accessory.price;
  }
}
